import Message from '../components/Message';

export default (function (w, d) {
    'use strict';

    function RegisterController() {
        this.initController();
    }

    RegisterController.prototype.initController = function () {
        (function ($) {
            $(function () {
                const $register_form = $('#register_form .sign-btn');

                $register_form.on('click', function (e) {
                    e.preventDefault();

                    const action = $('#register_form').attr('action');
                    const data = $('#register_form').serialize();

                    $.ajax({
                        method: 'post',
                        url: action,
                        data: data,
                        /* beforeSend: function () {
                            console.log( 'Start...' );
                        },*/
                        success: function (data) {
                            if (data.status === 'error') {
                                new Message(data.message, 'error');
                            } else if (data.status === 'success') {
                                /*!function (f, b, e, v, n, t, s) {
                                    if (f.fbq) return;
                                    n = f.fbq = function () {
                                        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
                                    };
                                    if (!f._fbq) f._fbq = n;
                                    n.push = n;
                                    n.loaded = !0;
                                    n.version = '2.0';
                                    n.queue = [];
                                    t = b.createElement(e);
                                    t.async = !0;
                                    t.src = v;
                                    s = b.getElementsByTagName(e)[0];
                                    s.parentNode.insertBefore(t, s)
                                }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

                                fbq('init', '1827035520774395');
                                fbq('track', 'CompleteRegistration');*/

                                new Message(data.message, 'success');

                                setTimeout(function () {
                                    if (data.url) {
                                        location.href = data.url;
                                    } else {
                                        location.reload();
                                    }
                                }, 1500);
                            }
                        },
                        /* complete: function () {
                            console.log( 'Done...' );
                        },*/
                        error: function (e) {
                            new Message('System error', 'error');
                        }
                    });
                });
            })
        }(jQuery))
    }

    return RegisterController;
}(window, document));

